export { default as JobsPreview } from './jobs-preview'
export { default as ArticlesPreview } from './articles-preview'
export { default as Testimonials } from './testimonials'
export { default as Advantages } from './advantages'
export { default as Solicitation } from './solicitation'
export { default as Values } from './values'
export { default as NewJobs } from './NewJobs'
